// extracted by mini-css-extract-plugin
export default {"add_device":"styles_add_device__5EJMA","header_text":"styles_header_text__kBJMz","add_item":"styles_add_item__+xGdE","image":"styles_image__Nvkz4","buttons":"styles_buttons__1GHtn"};